export enum Status {
  IDLE = "idle",
  LOADING = "loading",
  FAILED = "failed"
}

export const isIdle = (status: Status) => status === Status.IDLE;
export const isLoading = (status: Status) => status === Status.LOADING;
export const isFailed = (status: Status) => status === Status.FAILED;
